import {AppliedDiscount, Coupon, MultiCurrencyPrice} from '@wix/ecom_current-cart';
import {AppliedCouponModel} from '../models/AppliedCoupon.model';

type CouponWithPrivateFields = Coupon & {amount: MultiCurrencyPrice};

export const toAppliedCouponSDK = (appliedDiscounts: AppliedDiscount[]) => {
  const appliedCoupon = appliedDiscounts.find((discount) => discount.coupon);
  return appliedCoupon ? AppliedCouponModel.fromSDK(appliedCoupon.coupon as CouponWithPrivateFields) : undefined;
};
